import api from '../utils/baseUrl';

class CampaignLinkService {
    async getCampaignLinks(filters: {
        isActive?: boolean;
        search?: string;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
    } = {}) {
        try {
            const response = await api.get('api/campaignLinks', {params: filters});
            return Array.isArray(response.data.campaignLinks) ? response.data.campaignLinks : [];
        } catch (error) {
            console.error('Error fetching campaigns:', error);
            return [];
        }
    }

    async getCampaignLinkById(campaignLinkId: string) {
        try {
            const response = await api.get(`api/campaignLinks/${campaignLinkId}`);
            return response.data ?? {};
        } catch (error) {
            console.error('Error fetching campaign link:', error);
            return [];
        }
    }

    async updateCampaignLink(campaignLinkId: string, payload: object) {
        try {
            const response = await api.put(`/api/campaignLinks/${campaignLinkId}`, payload);
            return response.data.campaignLink ?? {};
        } catch (error) {
            console.error('Error creating campaign link:', error);
            return [];
        }
    }
}

export default new CampaignLinkService();